import Fetch from "./index";

export const getNativeClientPlatformPlan = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/native-client-platform-plan/" + id)
}

export const getNativeClientPlatformPlans = async (filters) => {
    const filter = new URLSearchParams(filters).toString();

    return Fetch(`/native-client-platform-plan?${filter}`)
}

export const updateNativeClientPlatformPlan = async (id, data) => {
    return Fetch(
        '/native-client-platform-plan/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const createNativeClientPlatformPlan = async (data) => {
    return Fetch(
        '/native-client-platform-plan/',
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const deleteNativeClientPlatformPlan = async (id) => {
    return Fetch(
        '/native-client-platform-plan/' + id,
        {
            method: 'DELETE',
        },
    )
}
